<div style="height: 870px;" data-cy="ar-payment">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;"
    data-cy="ar-payment-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-payment-header">
      <div class="section-header-title" data-cy="ar-payment-title">
        Receive Payment from {{ type }}
      </div>
      <div style="flex: 1;" data-cy="ar-payment-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;"
      data-cy="ar-payment-content">
      @if (isLoading) {
      <app-tdo-progress-spinner style="height: 100%;" data-cy="ar-payment-spinner"></app-tdo-progress-spinner>
      }
      @if (!isLoading) {
      <div style="flex: 1; overflow-y: hidden;" data-cy="ar-payment-loaded-content">
        <!--  body of modal-->
        <div class="flexbox-container" style="width:100% !important; flex-wrap: nowrap;" data-cy="ar-payment-container">
          <div class="flexbox-container-column" style="flex: 1; min-width: 0;" data-cy="ar-payment-left-column">
            <div class="top-left-column"
              style="background: var(--tdo-purple-light); padding-top: 10px; padding-bottom: 10px; margin-bottom: 10px; font-weight: bold; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; box-sizing: border-box;"
              title="Payment for: {{ this.globals.currentPatientFullName }}" data-cy="ar-payment-patient-name">
              Payment for: {{ this.globals.currentPatientFullName }}</div>
            <div class="flexbox-item top-left-column input-container-height" data-cy="ar-payment-from-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;"
                data-cy="ar-payment-from-field">
                <mat-label data-cy="ar-payment-from-label">From</mat-label>
                <mat-select data-cy="pay-from-list" [(ngModel)]="selectedContact">
                  @for (contact of contactList; track contact) {
                  <mat-option data-cy="pay-from-list-option" [value]="contact">
                    {{ contact?.FirstName + ' ' + contact?.LastName }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flexbox-item top-left-column input-container-height-middle"
              data-cy="ar-payment-amount-container">
              <div style="display: flex; flex-direction: row" data-cy="ar-payment-amount-row">
                <div style="flex-basis: 85%" data-cy="ar-payment-amount-input-container">
                  @if (this.selectedLedgerItem) {
                  <mat-form-field class="flex-column-item mat-select-margin"
                    style="width:100% !important; margin-top: 5px;" data-cy="ar-payment-credit-amount-field">
                    <mat-label data-cy="ar-payment-credit-amount-label">Credit Amount</mat-label>
                    <input matInput data-cy="pay-amount" [disabled]="true"
                      [value]="paymentAmount | currency:'USD':'symbol'"
                      (change)="saveCurrencyField($event, 'paymentAmount', '');">
                  </mat-form-field>
                  }
                  @if (!this.selectedLedgerItem) {
                  <div
                    style="max-height: 100px; overflow-y: auto; border-color: #00A1DD; border-width: 0px ; border-bottom-width: 2px; border-style: solid; padding-top: 10px; padding-bottom: 10px "
                    data-cy="ar-payment-doctor-amounts">
                    @for (charge of PaymentAmountForDoctors; track charge; let i = $index) {
                    <div data-cy="ar-payment-doctor-amount-row">
                      <div style="display: flex; height: 24px" data-cy="ar-payment-doctor-amount-item">
                        <mat-checkbox [checked]="charge.isSelected"
                          (change)="charge.isSelected = !charge.isSelected; PaymentAmountForDoctorSelection(charge)"
                          data-cy="ar-payment-doctor-checkbox"></mat-checkbox>
                        <div style="width: 180px" data-cy="ar-payment-doctor-name">
                          {{charge.DoctorName}}
                        </div>
                        <div
                          style="width: 70px; margin-right: 3px; border-width: 1px;border-style: solid;border-color: #00A1DD"
                          data-cy="ar-payment-doctor-amount-input-container">
                          <input matInput data-cy="pay-amount" [disabled]="!charge.isSelected"
                            [ngModel]="charge.amount | currency:'USD':'symbol'" (blur)="onAmountChanged($event, i)"
                            data-cy="ar-payment-doctor-amount-input">
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                  }
                </div>
                <div style="flex-basis: 15%;" data-cy="ar-payment-credit-button-container">
                  <div
                    [matTooltip]="dataCreditLedgerItems.length > 0 ? 'Credit exists - click to apply' : 'No credit available'"
                    data-cy="ar-payment-credit-tooltip">
                    <button data-cy="pay-credit-btn" mat-mini-fab color="primary"
                      [disabled]="dataCreditLedgerItems.length < 1 " (click)="openChooseLedgerItemWindow()">
                      <lucide-icon name="credit-card" [size]="20"></lucide-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="flexbox-item top-left-column input-container-height" style="margin-top: 10px;"
              data-cy="ar-payment-date-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;"
                data-cy="ar-payment-date-field">
                <mat-label data-cy="ar-payment-date-label">Post Date</mat-label>
                <input data-cy="pay-date" matInput [matDatepicker]="dateReceivedPicker" [(ngModel)]="datePostPayment"
                  [min]="this.dateReceivedMin">
                <mat-datepicker-toggle matSuffix [for]="dateReceivedPicker"
                  data-cy="ar-payment-date-toggle"></mat-datepicker-toggle>
                <mat-datepicker #dateReceivedPicker data-cy="ar-payment-date-picker"></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="flexbox-item top-left-column input-container-height"
              data-cy="ar-payment-received-date-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;"
                data-cy="ar-payment-received-date-field">
                <mat-label data-cy="ar-payment-received-date-label">Date Received</mat-label>
                <input data-cy="pay-received-date" matInput [matDatepicker]="dateReceivedPaymentPicker"
                  [(ngModel)]="dateReceivedPayment" [disabled]="this.isDisabledReceivedDate"
                  [min]="this.dateReceivedMin">
                <mat-datepicker-toggle matSuffix [for]="dateReceivedPaymentPicker"
                  data-cy="ar-payment-received-date-toggle"></mat-datepicker-toggle>
                <mat-datepicker #dateReceivedPaymentPicker data-cy="ar-payment-received-date-picker"></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="flexbox-container-column" style="flex: 1; margin-right: 10px;" data-cy="ar-payment-middle-column">
            <div class="top-left-column"
              style="background: var(--tdo-purple-light); padding-top: 10px; padding-bottom: 10px; margin-bottom: 10px; font-weight: bold"
              data-cy="ar-payment-middle-header">
              &nbsp;</div>
            <div class="flexbox-item top-center-column input-container-height" data-cy="ar-payment-type-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;"
                data-cy="ar-payment-type-field">
                <mat-label data-cy="ar-payment-type-label">Payment Type</mat-label>
                <mat-select data-cy="pay-type-list" [(ngModel)]="selectedPaymentMethod"
                  [disabled]="this.selectedLedgerItem" (selectionChange)="setPaymentMethod(); ">
                  @for (method of paymentMethods; track method) {
                  <mat-option data-cy="pay-type-list-option" [value]="method">
                    {{ method.Name }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if (this.DocPaymentProcessors.length>0 && selectedPaymentMethod?.enumARPayementTypeID ===
            EnumARPaymentType.CreditCard) {
            <div class="flexbox-item top-center-column input-container-height" data-cy="ar-payment-processor-container">
              @if (this.DocPaymentProcessors.length>0) {
              <div data-cy="ar-payment-processor-field-container">
                <mat-form-field style="width:100% !important;" data-cy="ar-payment-processor-field">
                  <mat-label data-cy="ar-payment-processor-label">Payment Processor</mat-label>
                  <mat-select data-cy="pay-account-list" [(ngModel)]="currentPaymentProcessorId"
                    (selectionChange)="setDocPaymentProcessor($event.value)">
                    @for (pp of DocPaymentProcessors; track pp) {
                    <mat-option data-cy="pay-account-list-option" [value]="pp.PaymentProcessorId">
                      {{ pp.Name }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }
            </div>
            }
            <div class="flexbox-item top-center-column input-container-height" data-cy="ar-payment-account-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;"
                data-cy="ar-payment-account-field">
                <mat-label data-cy="ar-payment-account-label">Payment Account</mat-label>
                <mat-select data-cy="pay-account-list" [(ngModel)]="depositARAccountID"
                  [disabled]="this.selectedLedgerItem">
                  @for (arAccount of arAccountsAll; track arAccount) {
                  <mat-option data-cy="pay-account-list-option" [value]="arAccount.ARAccountID">
                    {{ arAccount.AccountName}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flexbox-item top-center-column input-container-height"
              data-cy="ar-payment-description-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100%; padding-top: 5px;"
                data-cy="ar-payment-description-field">
                <mat-label data-cy="ar-payment-description-label">Description</mat-label>
                <input data-cy="pay-description" matInput value="" [(ngModel)]="paymentDescription">
              </mat-form-field>
            </div>
            <div class="flexbox-item top-center-column input-container-height" style="text-align: left"
              data-cy="ar-payment-token-container">
              <div class="flex-row" style="flex: 1; margin-right: 10px;" data-cy="ar-payment-token-row">
                @if (paymentTokens.length <= 1 && selectedPaymentMethod &&
                  selectedPaymentMethod.enumARPayementTypeID===EnumARPaymentType.CreditCard) { <mat-checkbox
                  [(ngModel)]="this.initializeToken" style="font-size: smaller;" data-cy="ar-payment-initialize-token">
                  Initialize Recurring Payment</mat-checkbox>
                  }
                  @if (checkValPayToken()) {
                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;"
                    data-cy="ar-payment-token-field">
                    <mat-label data-cy="ar-payment-token-label">Valid Payment Tokens</mat-label>
                    <mat-select [(ngModel)]="selectedToken" data-cy="ar-payment-token-select">
                      @for (tokens of paymentTokens; track tokens) {
                      <mat-option [value]="tokens" data-cy="ar-payment-token-option">
                        {{tokens.Description}}
                      </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  }
                  <!--make button for charge thing. whenever the selected value is add new or this is checked do pop-up for patient consent-->
              </div>
            </div>
            <div class="flexbox-item top-center-column" style="text-align: left; margin-top: 10px;"
              data-cy="ar-payment-action-buttons">
              <div style="flex: 1; margin-right: auto;margin-left: auto;text-align: center;"
                data-cy="ar-payment-action-buttons-container">
              </div>
            </div>
          </div>
          <div class="flexbox-container-column" style="flex: 2; padding-left: 10px" data-cy="ar-payment-right-column">
            <div class="top-left-column"
              style="background: var(--tdo-purple-light); padding-top: 10px; padding-bottom: 10px; font-weight: bold"
              data-cy="ar-payment-approved-header">Payment Distributions
              @if (currentARPayment() && selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard
              && selectedPaymentMethod?.enumARPayementETypeID === enumEPayTypeCredit ) {
              <button data-cy="payment-details-print-receipt-btn" (click)="openPaymentReceipt()"
                class="tdo-button tdo-close"
                style="margin-right: 10px; float:right;margin-top: -6px;margin-bottom: -9px;"
                [disabled]="isPrintingReceipt">Print Receipt</button>
              }
            </div>
            <div class="flexbox-item top-right-column" style="width:100%;" data-cy="ar-payment-approved-content">
              Payment Amount: <span class="applyPayment-amount" data-cy="ar-payment-approved-amount">{{
                this.approvedPaymentAmount | currency }}</span>
              &nbsp;<span class="applyPayment-orginalAmount"
              [ngClass]="!(currentARPayment() && this.approvedPaymentAmount < this.paymentAmount) ? 'hide-element' : ''"
                data-cy="ar-payment-approved-amount-note">(Full payment not approved)</span>
              <div style="padding-top:10px" data-cy="ar-payment-distribution-info">
                The payment was automatically distributed to the existing ledger items below starting with the oldest.
                If manual distribution is needed, please click the Clear Distributions button below and then manually
                enter the distributions.
              </div>
              <div style="padding-top: 10px; margin-top:10px; border-top: solid 1px #cccccc;"
                data-cy="ar-payment-remaining-section">
                <div style="display: flex;" data-cy="ar-payment-remaining-row">
                  <div style="flex: 1" data-cy="ar-payment-remaining-info">
                    Remaining Amount:
                    <span style="font-weight: bold" data-cy="ar-payment-remaining-amount">{{
                      this.paymentAmountNotDistributed | currency }}</span>
                    @if (paymentAmountNotDistributed > 0) {
                    <div style="padding-top:10px" data-cy="ar-payment-remaining-message">
                      This remaining amount will be recorded as a credit for the patient.
                    </div>
                    }
                  </div>
                  <div style="flex: 1; text-align: right; display: flex; gap: 15px;"
                    data-cy="ar-payment-clear-button-container">
                    <button data-cy="pay-clear-distributions-btn" class="tdo-button tdo-save"
                      [disabled]="isCreditSingleFee" (click)="clearDistributions()">
                      Clear Distributions
                    </button>
                    <button data-cy="pay-auto-apply-distributions-btn" class="tdo-button tdo-save"
                      (click)="autoApplyDistributions()">
                      Auto Apply Distributions
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  ledger table-->
        <div style="flex: 1; overflow-y: auto; height: 405px; margin-top: -10px;"
          data-cy="ar-payment-ledger-table-container">
          <tdo-table [dataSource]="this.dataLedgerItems" [isMultiSelection]="true" [isSearchable]="true"
            [isUsePaginator]="true" [footerData]="footerData" [searchPredicate]="searchPredicate"
            (rowSelected)="onRowSelected($event)" [cypressControlIdentifier]="'pay-fee-row'"
            data-cy="ar-payment-ledger-table">
            <tdo-table-column displayName="Post Date" propertyName="PostDate" isSortable="true" [rowTemplate]="postDate"
              data-cy="ar-payment-ledger-col-date">
              <ng-template #postDate let-row>
                @if (row.PostDate) {
                <div data-cy="ar-payment-ledger-date">{{ row.PostDate | date }}</div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Reference" propertyName="Reference" isSortable="true"
              [rowTemplate]="reference" data-cy="ar-payment-ledger-col-reference">
              <ng-template #reference let-row>
                @if (row.Reference) {
                <div data-cy="ar-payment-ledger-reference">{{ row.Reference }}</div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Code" targetObjectName="dataARTransactionItem" propertyName="Code"
              isSortable="true" [rowTemplate]="code" data-cy="ar-payment-ledger-col-code">
              <ng-template #code let-row>
                @if (row.model.dataARTransactionItemList && row.model.dataARTransactionItemList.Code) {
                <div data-cy="ar-payment-ledger-code">
                  {{ row.model.dataARTransactionItemList.Code }}
                </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Description" propertyName="Description" isSortable="true"
              [rowTemplate]="description" data-cy="ar-payment-ledger-col-description">
              <ng-template #description let-row>
                @if (row.model.Description) {
                <div style="max-width: 500px; padding-top: 4px; padding-bottom: 4px;"
                  data-cy="ar-payment-ledger-description">
                  {{ row.model.Description }}
                </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="AR Account" propertyName="ARAccountID" isSortable="true"
              [rowTemplate]="araccount" data-cy="ar-payment-ledger-col-account">
              <ng-template #araccount let-row>
                @if (row.model.DoctorARLocId) {
                <div data-cy="ar-payment-ledger-account">
                  {{ this.returnARAccountName(row.model.DoctorARLocId) }}
                </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Billed" propertyName="Amount1" isSortable="true" [rowTemplate]="debit"
              data-cy="ar-payment-ledger-col-billed">
              <ng-template #debit let-row>
                @if (isPayable(row.model)) {
                <div data-cy="ar-payment-ledger-billed">
                  {{ row.model.Amount | currency }}
                </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Payments" propertyName="PaymentsTotal" isSortable="true"
              [rowTemplate]="payments" data-cy="ar-payment-ledger-col-payments">
              <ng-template #payments let-row>
                @if (row.model.PaymentsTotal) {
                <div data-cy="ar-payment-ledger-payments">
                  {{ row.model.PaymentsTotal | currency }}
                </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Amount Due" propertyName="RunningBalance" isSortable="true"
              [rowTemplate]="due" data-cy="ar-payment-ledger-col-due">
              <ng-template #due let-row>
                <div data-cy="ar-payment-ledger-due">{{ row.model.AmountDuePatient | currency }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Apply" propertyName="ApplyPayment" isSortable="true" [rowTemplate]="apply"
              data-cy="ar-payment-ledger-col-apply">
              <ng-template #apply let-row>
                <div class="input-container-height" data-cy="ar-payment-ledger-apply-container">
                  <mat-form-field floatLabel='never' [style.width.px]=80 data-cy="ar-payment-ledger-apply-field">
                    <input data-cy="pay-distribution-amount-btn" matInput placeholder="" width="80px"
                      style="font-weight: bold" [ngClass]="!(row.model.AmountDuePatient > 0) ? 'hide-element' : ''"
                      (change)="saveCurrencyField($event, 'ApplyPayment', row.model.LedgerID); this.setPaymentAmountDistributionRemaining();"
                      [ngModel]="row.model.ApplyPayment | currency">
                  </mat-form-field>
                </div>
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
      </div>
      }
    </div>
    <!--  FOOTER-->
    @if (!isLoading) {

    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="ar-payment-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="ar-payment-footer-spacer"></div>
      <button data-cy="pay-cancel-bottom-btn" (click)="close(false); cancelClicked();" class="tdo-button tdo-close"
        style="margin-right: 10px;">Cancel</button>
      <button data-cy="pay-save-bottom-btn" class="tdo-button tdo-save" style="margin-right: 6px;"
        [disabled]="IsChargeDisabled()" (click)="submitPayment($event)">Save Payment</button>
    </div>
    }
  </div>
</div>
@if (isPaymentProcessing()) {
<div class="spinner-container" [class.payment-processing]="isPaymentProcessing()"
  data-cy="ar-insurance-payment-spinner-container">
  <mat-spinner data-cy="ar-insurance-payment-spinner"></mat-spinner>
</div>
}